import { mediaQueryMobile } from '../mixins';

const theme = {
  fontFamily: 'Poppins, sans serif',
  colors: {
    iris: [
      '#f3ebff',
      '#e2cfff',
      '#b482ff',
      '#a263ff',
      '#8f44ff',
      '#8f44ff',
      '#8f44ff',
      '#8f44ff',
      '#8f44ff',
      '#8f44ff',
    ],
  },
  other: {
    fonts: {
      body: 'Inter, sans serif',
    },
    dateFormats: {
      default: 'd MMM yy, hh:mm:ss a XXX',
    },
    fontWeights: {
      regular: '400',
      medium: '500',
      semiBold: '600',
      bold: '700',
    },
  },
};

// eslint-disable-next-line no-unused-vars
export const globalAppTheme = (theme) => {
  return {
    '.mantine-Button-filled': {
      transition: 'opacity 100ms ease',
      ':hover': {
        opacity: 0.85,
      },
    },

    // Hack to fix notification container position in mobile devices.
    // TODO: This is probably fixed in v4.2.1
    '.mantine-Notification-root': {
      backgroundColor: '#3d3d3d',
      [mediaQueryMobile()]: {
        left: '50%',
        transform: 'translateX(-39%)',
      },
      '.mantine-Notification-title': {
        color: '#fff',
      },
      '.mantine-Notification-body': {
        '.mantine-Notification-description.mantine-Text-root': {
          color: '#fff',
        },
      },
      '.mantine-ActionIcon-root': {
        color: '#fff',
        ':hover': {
          color: 'unset',
        },
      },
    },
  };
};

export default theme;
